import { CSSProperties } from "react";

export const InputStyles: CSSProperties = {
    flexGrow: 1,
    height: '40px',
    fontSize: '12pt',
    paddingLeft: '8px'
    // height: '70px',
    // // width: '200px',
    // borderRadius: '10px',
    // border: '1px solid gray',
    // outline: 'none',
    // color: 'gray',
    // flex: 1,
    // fontSize: '18px',
    // backgroundColor: 'rgba(0,0,0,0.04)',
    // padding: '8px'
}